import apiService from 'apiService'
import React, { useEffect, useState } from 'react'
import Select from 'react-select'

export default function UserRolesSelect({ handler }) {
    const [userRoles, setUserRoles] = useState([])

    const getUserRoles = async () => {
        const roles = await apiService.get('/users/roles')
        if (roles === null) return
        roles.map(el => {
            el.label = el.description.toUpperCase()
            el.value = el.id
        })
        setUserRoles(roles)
    }

    const handleChange = e => {
        handler(e.id)
    }

    useEffect(() => {
        getUserRoles()
    }, [])

    return (
        <>
            <div className="w-full lg:w-12 px-4">
                <div className="relative w-full mb-3">
                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">ΡΟΛΟΣ</label>
                    <Select options={userRoles} placeholder="Επιλογή Ρόλου" onChange={handleChange} />
                </div>
            </div>
        </>
    )
}
